import React, { useContext } from 'react';
import Card, { Item } from '../Card';
import { Page } from '../PageCard';
import { PageCardUIContext } from '../../PageCardUIContext';
import PageHeader from '../PageCard/PageHeader';
import CardContainer from '../CardContainer';
import { useWeddingWebsiteQuery } from '../../generated/graphql';
import CoverPhotoPortrait from './CoverPhotoPortrait';
import BasicInfo from './BasicInfo';
import OnlineRsvp from './OnlineRsvp';
import styles from './liteSiteHomePageCard.scss';

interface Props {
  page: Page;
}

const LiteHomePageCard: React.FC<Props> = ({ page }) => {
  const { data } = useWeddingWebsiteQuery();
  const { isPageOpenObj, togglePageOpen } = useContext(PageCardUIContext);
  const open = isPageOpenObj[page.id];

  return (
    <CardContainer>
      <Card>
        <PageHeader page={page} open={open} toggleOpen={(): void => togglePageOpen(page.id)} hasDropdown={false} />
        {open ? (
          <>
            <Item showGrabber={false} className={styles.homePageItem}>
              <div className={styles.homePageFlexBox}>
                <CoverPhotoPortrait page={page} />
                <BasicInfo data={data} />
              </div>
            </Item>
            <Item className={styles.itemOverride} showGrabber={false}>
              <OnlineRsvp />
            </Item>
          </>
        ) : null}
      </Card>
    </CardContainer>
  );
};

export default LiteHomePageCard;
